import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  DialogProps,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { VerticalStack } from "./primitives/Stacks";
import { DialogTransition } from "./primitives/DialogTransition";
import CloseIcon from "@mui/icons-material/Close";

export const ConfirmDeleteDialog: React.FC<
  DialogProps & {
    dialogTitle: string;
    dialogMessage: string;
    onConfirm: () => void;
    onDiscard: () => void;
  }
> = ({ dialogTitle, dialogMessage, onDiscard, onConfirm, ...dialogProps }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      onClose={onDiscard}
      {...dialogProps}
    >
      <AppBar color="error" elevation={0} position="relative">
        <Toolbar>
          <Typography mr={2} flex={1} variant="h6" component="div">
            {dialogTitle}
          </Typography>
          <Tooltip title={t("common.close")}>
            <IconButton
              aria-label={`${t("common.close")}`}
              color="inherit"
              edge="end"
              onClick={onDiscard}
            >
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <DialogContent
        sx={{
          minHeight: "300px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Typography color="text.secondary" gutterBottom>
          {dialogMessage}
        </Typography>
        <VerticalStack>
          <Button
            color="error"
            fullWidth
            onClick={onConfirm}
            size="large"
            type="submit"
          >
            {t("common.delete")}
          </Button>
          <Button color="error" fullWidth onClick={onDiscard} variant="text">
            {t("common.cancel")}
          </Button>
        </VerticalStack>
      </DialogContent>
    </Dialog>
  );
};
